import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiftDetailComponent } from './gift-detail.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { MatInputModule } from "@angular/material/input";
import { ReactiveFormsModule } from "@angular/forms";
import { TruncateModule } from "@pipes/truncate/truncate.module";
import { TranslateDomainModule}  from "@web/app/pipes/translate/translate-domain.module";
import { GiftLanguageChooserModule } from '../gift-language-chooser/gift-language-chooser.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { InfoIconHoverableModule } from '../../info-icon-hoverable/info-icon-hoverable.module';
import { MatMenuModule } from '@angular/material/menu';
import { WsTooltipModule } from '@web/util/ws-ui/ws-tooltip/ws-tooltip.module';
import { ExternalSyncButtonModule } from '../../external-sync-button/external-sync-button.module';
import { WsUiModule } from '@web/util/ws-ui/ws-ui.module';

@NgModule({
  declarations: [GiftDetailComponent],
  entryComponents: [GiftDetailComponent],
  exports: [GiftDetailComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    MatInputModule,
    ReactiveFormsModule,
    TruncateModule,
    TranslateDomainModule,
    MatDatepickerModule,
    MatNativeDateModule,
    GiftLanguageChooserModule,
    InfoIconHoverableModule,
    ExternalSyncButtonModule,
    MatMenuModule,
    WsTooltipModule,
    WsUiModule,
  ]
})
export class GiftDetailModule { }